import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Input } from '@fiverr-private/fit';
import { updateCalculator, updatePrice, updateVoData } from '../../../../actions/packages';
import { getPackageById } from '../../../../reducers/packages';
import { isVoiceOver } from '../../../../utils/packagesUtils';
import calculateVoData from '../../../../utils/voiceOver';
import { CALC_MAX } from '../../../../utils/packagesUtils/constants';

const onKeyUp = (e) => {
    const inputEl = e.target;

    // In case the user clears input we want it to stay empty
    if (inputEl.value === '') {
        return true;
    }

    let newValue = Number(inputEl.value); // Number is also for removal of a leading zero if exists

    if (newValue > CALC_MAX) {
        newValue = CALC_MAX;
    }
    inputEl.value = newValue;
};

class CalculatorInput extends Component {

    constructor() {
        super();

        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }

    onChange(e) {
        const value = e.target.value;

        if (Number(value) > CALC_MAX) {
            return;
        }

        const newValue = value !== '' ? Number(value) : value;

        this.recalculatePrice(newValue);
    }

    onBlur(e) {
        const { initValue } = this.props;
        const { value } = e.target;

        // When the input is empty, change it and the price to default
        if (value === '') {
            this.recalculatePrice(initValue);
        }
    }

    recalculatePrice(newValue) {
        const {
            updateCalculatorAndPrice,
            updateCalculator,
            updateVoData,
            initValue,
            packageId,
            id
        } = this.props;
        const { general } = this.context;

        if (isVoiceOver(general)) {
            updateCalculator({ id, value: newValue });
            const scriptLength = Math.max(initValue, Number(newValue));
            updateVoData({ scriptLength, id, packageId });
        } else {
            updateCalculatorAndPrice({ id, value: newValue });
        }
    }

    render() {
        const {
            currentValue
        } = this.props;

        return (
            <Input className="calculator-input"
                type="number"
                max={CALC_MAX}
                value={currentValue}
                onChange={this.onChange}
                onKeyUp={onKeyUp}
                onBlur={this.onBlur}/>
        );
    }
}

CalculatorInput.propTypes = {
    packageId: PropTypes.number,
    id: PropTypes.number,
    currentValue: PropTypes.number,
    initValue: PropTypes.number,
    updateCalculator: PropTypes.func,
    updateVoData: PropTypes.func,
    updateCalculatorAndPrice: PropTypes.func
};

CalculatorInput.defaultProps = {
    updateCalculator: () => true,
    updateVoData: () => true,
    updateCalculatorAndPrice: () => true
};

CalculatorInput.contextTypes = {
    general: PropTypes.object
};

const dispatchUpdateCalculatorAndPrice = ({ id, value }) => (dispatch) => {
    dispatch(updateCalculator({ calculatorId: id, value }));
    dispatch(updatePrice());
};

const dispatchUpdateCalculator = ({ id, value }) => (dispatch) => {
    dispatch(updateCalculator({ calculatorId: id, value }));
};

const dispatchUpdateVoData = ({ scriptLength, id, packageId }) => (dispatch, getState) => {
    const { packages } = getState();
    const packageData = getPackageById(packages, packageId);
    const voData = calculateVoData({ scriptLength, calculatorId: id, packageData });
    dispatch(updateVoData({ voData }));
};

const mapStateToPackageCalculatorProps = (state, ownProps) => ({ ...ownProps });

export { CalculatorInput };

export default connect(
    mapStateToPackageCalculatorProps,
    {
        updateCalculator: dispatchUpdateCalculator,
        updateVoData: dispatchUpdateVoData,
        updateCalculatorAndPrice: dispatchUpdateCalculatorAndPrice
    }
)(CalculatorInput);
